import React, { useState } from 'react';
import { Modal, Row, Col, Container } from 'react-bootstrap';
import '../App.css';

const galleryContext = require.context('../images', false, /\.(png|jpe?g|webp)$/);

const galleryImages = galleryContext
  .keys()
  .sort((a, b) => a.localeCompare(b, 'ru', { numeric: true, sensitivity: 'base' }))
  .reverse()
  .map((path, index) => ({
    id: index + 1,
    image: galleryContext(path)
  }));

function Photo() {
  const [showPreview, setShowPreview] = useState(false);
  const [currentImage, setCurrentImage] = useState('');

  return (
    <main className="page-main">
      <Container className="inner-page pb-5">
        <section className="section-block">
          <div className="section-heading">
            <h2>Фотогалерея храма</h2>
            <p>
              Фотолетопись приходской жизни. Показаны все изображения из папки сайта, нажмите на фото для
              увеличения.
            </p>
          </div>

          <Row className="g-4 mt-1">
            {galleryImages.map((item) => (
              <Col key={item.id} xs={12} sm={6} lg={4}>
                <article className="surface-card photo-card h-100">
                  <button
                    type="button"
                    className="photo-preview-btn"
                    onClick={() => {
                      setCurrentImage(item.image);
                      setShowPreview(true);
                    }}
                  >
                    <img src={item.image} alt={`Фото прихода ${item.id}`} className="gallery-image" loading="lazy" />
                  </button>
                </article>
              </Col>
            ))}
          </Row>
        </section>
      </Container>

      <Modal show={showPreview} onHide={() => setShowPreview(false)} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Просмотр фотографии</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <img src={currentImage} alt="Увеличенное изображение" className="img-fluid" loading="lazy" />
        </Modal.Body>
      </Modal>
    </main>
  );
}

export default Photo;
